module.exports = __webpack_public_path__ + "static/media/inf_42pog54p.02b1548d.mp3";